// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: -fR3b8VmLe9a
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicInvoiceItem.module.css"; // plasmic-import: -fR3b8VmLe9a/css
import Line1Icon from "./icons/PlasmicIcon__Line1"; // plasmic-import: MRg3okKdNvAo/icon

createPlasmicElementProxy;

export const PlasmicInvoiceItem__VariantProps = new Array();

export const PlasmicInvoiceItem__ArgProps = new Array(
  "item",
  "quantity",
  "amount"
);

const $$ = {};

function PlasmicInvoiceItem__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <Stack__
      as={"div"}
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox___860Y)}>
        <div className={classNames(projectcss.all, sty.freeBox__p2T3)}>
          {renderPlasmicSlot({
            defaultContents: "Social Media Management",
            value: args.item,
            className: classNames(sty.slotTargetItem)
          })}
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__lqnQn)}>
          {renderPlasmicSlot({
            defaultContents: "$300",
            value: args.amount,
            className: classNames(sty.slotTargetAmount)
          })}
        </div>
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__nzO3O)}>
        {renderPlasmicSlot({
          defaultContents: "Qty 1",
          value: args.quantity,
          className: classNames(sty.slotTargetQuantity)
        })}
      </div>
      <Line1Icon
        data-plasmic-name={"svg"}
        data-plasmic-override={overrides.svg}
        className={classNames(projectcss.all, sty.svg)}
        role={"img"}
      />
    </Stack__>
  );
}

const PlasmicDescendants = {
  root: ["root", "svg"],
  svg: ["svg"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicInvoiceItem__ArgProps,
          internalVariantPropNames: PlasmicInvoiceItem__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicInvoiceItem__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicInvoiceItem";
  } else {
    func.displayName = `PlasmicInvoiceItem.${nodeName}`;
  }
  return func;
}

export const PlasmicInvoiceItem = Object.assign(
  // Top-level PlasmicInvoiceItem renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    svg: makeNodeComponent("svg"),
    // Metadata about props expected for PlasmicInvoiceItem
    internalVariantProps: PlasmicInvoiceItem__VariantProps,
    internalArgProps: PlasmicInvoiceItem__ArgProps
  }
);

export default PlasmicInvoiceItem;
/* prettier-ignore-end */
